import { render, staticRenderFns } from "./ProductCompare.vue?vue&type=template&id=5637ae38&"
import script from "./ProductCompare.vue?vue&type=script&lang=js&"
export * from "./ProductCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports